import React from "react";
import ReactDOM from "react-dom";
import AddFundsPrepaid from "../components/add_funds/add_funds_prepaid";
import styled from "styled-components/macro";
import { inEmbedMode } from "../odc-ui";

const Explanation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 50px;
`;

const ExternalPurchasePrepaid = () => {
  const renderPreamble = () =>
    inEmbedMode() ? null : (
      <Explanation>
        <div>
          Thank you for choosing Heathcoin® Prepaid. To complete your purchase,
          please fill out the form below.
        </div>
      </Explanation>
    );

  return (
    <div>
      <AddFundsPrepaid
        theme="paige"
        external={true}
        renderPreamble={renderPreamble}
      />
    </div>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById(
    "external-purchase-prepaid-mount-point"
  );
  ReactDOM.render(<ExternalPurchasePrepaid />, mountPoint);
});
